<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Ø</h1>
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/oe/oe_02-highres.jpg" src="static/images/oe/oe_02.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">
            The inspiration for the Ø chair came from the rough natured and windy Nordic islands and their tiny wooden houses.
          </p>
          <p>
            “I designed a chair that would bring warmth and comfort when being in both out - and indoor - spaces. It should functionally and aesthetically fit in the natural landscape and enhance the atmosphere.“</p>
          <br>
          <p>
            The prototype was made locally using ash wood and fishing net. The net is attached to the bent wooden frame with the same technique used in traditional hand held fishing nets. As an addition comes a knitted woolen blanket that can be spread to bring softness, comfort and warmth. Ø chair was designed as a Master thesis project for the Royal Danish Academy of Fine Arts, KADK.
          </p>
          <br>
          <p>
            Big thanks to Morten Husum Nielsen, who helped and guided me with the woodwork and Tuulia Tulisalmi for knitting the beautiful blanket.
          </p>
          <br>
          <p>
            Photography: Aino Michelsen, Damir Krdzovic
          </p>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/oe/oe_03-highres.jpg" src="static/images/oe/oe_03.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/oe/oe_04-highres.jpg" src="static/images/oe/oe_04.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/oe/oe_05.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/oe/oe_06.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Oe.vue